export interface KeyValuePair<K = any, V = any> {
  key: K;
  value: V;
}
